import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { GlobalProvider } from './context/GlobalContext';

import authReducer from './reducers/authReducer';
import questionsReducer from './reducers/questionsReducer';
import answersReducer from './reducers/answersReducer';

import Routes from './pages/GlobalRouter';
import changesReducer from './reducers/changesReducer';

function App() {

  function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);

    return function combination(state = {}, action) {
      const nextState = {}
      for (let i = 0; i < reducerKeys.length; i++) {
        const key = reducerKeys[i];
        const reducer = reducers[key]
        const previousStateForKey = state[key]
        const nextStateForKey = reducer(previousStateForKey, action)
        nextState[key] = nextStateForKey;
      }
      return nextState;
    }
  }

  const reducers = combineReducers({
    auth: authReducer,
    questions: questionsReducer,
    answers: answersReducer,
    changes: changesReducer,
  });

  const initialState = reducers({}, { type: '__INIT__' });

  return (
    <GlobalProvider
      reducers={reducers}
      initialState={initialState}
    >
      <div className="app-container">
        <Router>
          <Routes />
        </Router>
      </div>
    </GlobalProvider>
  );
}

export default App;
